import { render } from "./TransportInStep.vue?vue&type=template&id=3b25a534"
import script from "./TransportInStep.vue?vue&type=script&lang=js"
export * from "./TransportInStep.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__